import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  rootContainer: {
    margin: "0 auto",
  },
  iconContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  textContainer: {
    marginLeft: "5%",
    marginRight: "5%",

    

    textAlign: "center",
  },
  tables: {

    
    width: "100%",
    height: "100%",
  },
  tableContainer: {
  marginLeft: "5%",
    marginRight: "5%",


    marginBottom: 10,
  },
 
  buttons: {
    display: "flex",
    marginRight: "5%",
  },
  
  bar: {
    display: "flex",
	 height: "55px",
    justifyContent: "space-between",
	overflow: "auto",
	    
  marginBottom: 10,
  },
  invoiceContainer: {
    width: "100%",
    backgroundColor: "#f5f5f5",
  },
  invoice: {
    width: "100%",
    height: "100%",
    backgroundColor: "#f5f5f5",
  },

  focused: {
    "& .MuiInput-underline:after": {
      borderBottomColor: "#0070f2",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: "#0070f2",
    },
  },

 
    save: {
      display: "flex",
    marginLeft: "5%",
	marginRight: "10px"
    },
  


});
